import React from "react";
import YoutubeView from "./YoutubeView";
import "../queture/_queture.scss";
import { FormattedMessage } from "react-intl";

const Additional = ({ youtubeUrl, curPage, onSendMessage, viewType }) => {
  return (
    <div>
      {curPage === 0 ? (
        <div className="queturepoint-layout">
          <div className="queturepoint-layout-wrap">
            <div className="small-title">Youtube</div>
            <div className="big-title u-color-red">{"추가영상"}</div>
            {/* <div className="wrap">
              <div className="page-content-title u-color-red">
                <span>
                  <FormattedMessage id={"classroom.quetureDescTitle"} />
                </span>
                <span className="speech-bubble">
                  <FormattedMessage id={"classroom.queture-point"} />
                  <span></span>
                </span>
              </div>
              <p className="page-content-ment">
                
              </p>
            </div> */}
          </div>
        </div>
      ) : (
        <YoutubeView
          url={youtubeUrl}
          viewType={viewType}
          onSendMessage={onSendMessage}
        />
      )}
    </div>
  );
};

export default Additional;
